var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex flex-row"},[_c('div',{staticClass:"w-full max-w-screen-xl flex flex-col lg:flex-col"},[_c('ProfileGeneral'),_c('ProfilePassword')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }